/**
 * Copyright (C) Sitevision 2002-2026, all rights reserved
 */

const PARAMS = {
  query: 'query',
  facetPrefix: '100.',
  sort: 'csrtp',
  pagination: 'startAtHit',
  submitButton: 'submitButton',
};

const hasFacetParams = (searchParams) =>
  [...searchParams.keys()].some((key) => key.startsWith(PARAMS.facetPrefix));

const deleteFacetParams = (searchParams) => {
  const facetKeys = [];
  for (const key of searchParams.keys()) {
    if (key.startsWith(PARAMS.facetPrefix)) {
      facetKeys.push(key);
    }
  }
  facetKeys.forEach((key) => searchParams.delete(key));
};

const resolveOperation = (incoming) => {
  if (hasFacetParams(incoming) || incoming.has(PARAMS.sort)) {
    return 'refinement';
  }
  if (incoming.has(PARAMS.pagination)) {
    return 'pagination';
  }
  if (incoming.has(PARAMS.query)) {
    return 'query';
  }
  return '';
};

const applyIncomingRefinementParams = (current, incoming) => {
  for (const [key, value] of incoming.entries()) {
    if (key.startsWith(PARAMS.facetPrefix)) {
      current.append(key, value);
    } else if (key === PARAMS.sort) {
      current.set(key, value);
    }
  }
};

export const updateSearchUrlParams = (urlParams, operation) => {
  const pageUrl = new URL(window.location.href);
  const incoming = new URLSearchParams(urlParams.split('?').at(-1));
  const current = pageUrl.searchParams;
  const currentOperation = operation || resolveOperation(incoming);

  // New search query: reset paging, sort and facets.
  if (currentOperation === 'query') {
    current.delete(PARAMS.pagination);
    current.delete(PARAMS.sort);
    deleteFacetParams(current);
  }

  // Facet/sort refinement: reset paging and replace refinement params.
  if (currentOperation === 'refinement') {
    current.delete(PARAMS.pagination);
    current.delete(PARAMS.sort);
    deleteFacetParams(current);
    applyIncomingRefinementParams(current, incoming);
  }

  if (incoming.has(PARAMS.query)) {
    current.set(PARAMS.query, incoming.get(PARAMS.query));
  }

  if (currentOperation !== 'query' && currentOperation !== 'refinement' && incoming.has(PARAMS.sort)) {
    current.set(PARAMS.sort, incoming.get(PARAMS.sort));
  }

  if (currentOperation === 'pagination' && incoming.has(PARAMS.pagination)) {
    current.set(PARAMS.pagination, incoming.get(PARAMS.pagination));
  } else if (!currentOperation && incoming.has(PARAMS.pagination)) {
    current.set(PARAMS.pagination, incoming.get(PARAMS.pagination));
  }

  current.delete(PARAMS.submitButton);

  history.replaceState({}, '', pageUrl);
};
